import React from "react";

function Modal({ isOpen, onClose, children }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div className="absolute inset-0 bg-gray-800 opacity-50"></div>
      <div className="bg-gray-50 rounded-lg shadow-lg z-10 w-2/3 relative max-h-[90vh] flex flex-col">
        <div className="flex justify-end p-2 sticky top-0 bg-gray-50 rounded-t-lg z-10">
          <button className="text-gray-600 hover:text-gray-900 font-bold px-2" onClick={onClose}>
            X
          </button>
        </div>
        <div className="px-6 pb-6 overflow-y-auto">
          {children}
        </div>
      </div>
    </div>
  );
}

export default Modal;
